import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconLock: React.FC<IconProps> = ({ width = 10, height = 18, color = 'black' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 668 693"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M109 294.153V225.667C109 101.403 209.736 0.666687 334 0.666687C458.263 0.666687 559 101.403 559 225.667V294.153C596.16 296.93 620.357 303.933 638.043 321.623C667.333 350.913 667.333 398.053 667.333 492.333C667.333 586.613 667.333 633.753 638.043 663.043C608.753 692.333 561.613 692.333 467.333 692.333H200.667C106.386 692.333 59.2454 692.333 29.956 663.043C0.666687 633.753 0.666687 586.613 0.666687 492.333C0.666687 398.053 0.666687 350.913 29.956 321.623C47.6437 303.933 71.8417 296.93 109 294.153ZM159 225.667C159 129.017 237.35 50.6667 334 50.6667C430.65 50.6667 509 129.017 509 225.667V292.453C496.233 292.333 482.383 292.333 467.333 292.333H200.667C185.616 292.333 171.767 292.333 159 292.453V225.667Z"
                fill={color}
            />
        </svg>
    );
};

export default IconLock;
